"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var Subject_1 = require("rxjs/Subject");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_entity_search_client_js_1 = require("@synisys/idm-entity-search-client-js");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var operators_1 = require("rxjs/operators");
var idm_de_service_client_js_1 = require("@synisys/idm-de-service-client-js");
var idm_dynamic_forms_ui_1 = require("@synisys/idm-dynamic-forms-ui");
var of_1 = require("rxjs/observable/of");
var Observable_1 = require("rxjs/Observable");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_dynamic_forms_controls_1 = require("@synisys/idm-dynamic-forms-controls");
var dialog_action_1 = require("../../enums/dialog-action");
var idm_validation_calculation_service_client_js_1 = require("@synisys/idm-validation-calculation-service-client-js");
var warning_dialog_component_1 = require("../../../../shared/dialogs/warning/warning-dialog.component");
var dialog_config_helper_1 = require("../../../../shared/utils/dialog-config-helper");
var fromPromise_1 = require("rxjs/observable/fromPromise");
var lodash_1 = require("lodash");
var BulkPickerPopupComponent = /** @class */ (function () {
    function BulkPickerPopupComponent(dialogRef, kbService, deService, entitySearchService, classifierService, dialog, extractionService, validationService, deSerializationService, data) {
        this.dialogRef = dialogRef;
        this.kbService = kbService;
        this.deService = deService;
        this.entitySearchService = entitySearchService;
        this.classifierService = classifierService;
        this.dialog = dialog;
        this.extractionService = extractionService;
        this.validationService = validationService;
        this.deSerializationService = deSerializationService;
        this.data = data;
        this.rowItems = [];
        this.columnMetaFields = [];
        this.keywordMetaFields = [];
        this.selectedItemFields = [];
        this.selectedSubEntities = [];
        this.updateEntitiesSubject = new Subject_1.Subject();
        this.pageLimit = 7;
        this.totalCount = 0;
        this.totalPageCount = 0;
        this._currentPage = 0;
        this.isReady = false;
        this.inDrawer = false;
        this._destroy$ = new Subject_1.Subject();
        this._entityComparisonHelper = new idm_de_core_frontend_1.EntityComparisonHelper(kbService);
    }
    BulkPickerPopupComponent.getConfig = function (entity, buttonConfig, targetMainEntityMetaField, currentLanguageId, form, categoryId, subEntityFieldId, rootTableTitle, mainEntityImageFieldName, selectedSubEntities, newEntity, buttonId, idPrefix) {
        var dialogConfig = new material_1.MatDialogConfig();
        dialogConfig.width = '1200px';
        dialogConfig.height = 'auto';
        dialogConfig.autoFocus = true;
        dialogConfig.disableClose = true;
        dialogConfig.data = {
            entity: entity,
            buttonConfig: buttonConfig,
            targetMainEntityMetaField: targetMainEntityMetaField,
            currentLanguageId: currentLanguageId,
            form: form,
            categoryId: categoryId,
            subEntityFieldId: subEntityFieldId,
            rootTableTitle: rootTableTitle,
            mainEntityImageFieldName: mainEntityImageFieldName,
            selectedSubEntities: selectedSubEntities,
            newEntity: newEntity,
            buttonId: buttonId,
            idPrefix: idPrefix
        };
        return dialogConfig;
    };
    BulkPickerPopupComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.setPopupData(this.data);
        document.querySelector('.mat-dialog-container').classList.add('ejustice-bulk-picker-size');
        document.querySelector('.mat-dialog-container').closest('.cdk-overlay-pane').classList.add('ejustice-bulk-picker-selector');
        this.updateEntitiesSubject.pipe(operators_1.switchMap(function () {
            return _this.entitySearchService.loadPortfolioItemsByFields(_this.mainEntityCategoryId, new idm_de_core_frontend_1.PagingOptions(_this._currentPage, _this.pageLimit), null, _this._filterCriteria, null, [idm_um_permission_client_js_1.CategoryPermissionType.VIEW], _this.buttonConfig.fieldsToLoad);
        }), operators_1.takeUntil(this._destroy$)).subscribe(function (entities) {
            _this.rowItems = entities.getData();
            _this.totalCount = entities.getTotalRowCount();
            _this.totalPageCount = Math.ceil(_this.totalCount / _this.pageLimit);
        });
        this.inDrawer = this._form && this._form.inDrawer;
        this._form.actionNotifier
            .pipe(operators_1.switchMap(function (action) {
            if (_this._isAddAction) {
                var subFromActions = [idm_dynamic_forms_ui_1.ActionNotifierKey.SUB_FORM_SAVE_ACTION, idm_dynamic_forms_ui_1.ActionNotifierKey.SUB_FORM_CLOSE_ACTION];
                if (subFromActions.includes(action.key)) {
                    if (action.key === idm_dynamic_forms_ui_1.ActionNotifierKey.SUB_FORM_SAVE_ACTION && action.data instanceof idm_de_service_client_js_1.SubEntity) {
                        var subEntities_1 = _this.entity.getProperty(_this.subEntityCategoryId).value;
                        return _this.isSubEntityUnique(subEntities_1[subEntities_1.length - 1])
                            .pipe(operators_1.map(function (isUnique) {
                            if (isUnique) {
                                _this.selectedSubEntities.push(subEntities_1[subEntities_1.length - 1]);
                            }
                            else {
                                subEntities_1.pop();
                                _this.dialog.open(warning_dialog_component_1.WarningDialogComponent, dialog_config_helper_1.DialogConfigHelper.getWarningDialogConfig('cms_warning', 'tng_data_already_added'));
                            }
                        }));
                    }
                    else {
                        _this.entity.getProperty(_this.subEntityCategoryId).value.pop();
                    }
                    _this._isAddAction = false;
                }
            }
            return of_1.of(null);
        }), operators_1.takeUntil(this._destroy$)).subscribe();
        var searchFilterName$ = this.buttonConfig.searchFilter.lookupFieldCompoundName ?
            this.classifierService.loadClassifiersByIds(this.buttonConfig.searchFilter.lookupFieldCompoundName, [this.buttonConfig.searchFilter.lookupFieldValue])
                .concatMap(function (classifiersResponse) {
                return _this.extractionService.extractNameFromClassifierCached(classifiersResponse.getData()[0], _this.buttonConfig.searchFilter.lookupFieldCompoundName, _this.currentLanguageId);
            })
            : of_1.of(null);
        var subEntityMetaFields$ = this.kbService.getMetaFields(this.subEntityCategoryId);
        var mainEntityMetaFields$ = this.kbService.getMetaFields(this.mainEntityCategoryId);
        var dummySubEntity$ = this.deService.createBlankSubEntity(this.subEntityCategoryId).pipe(operators_1.concatMap(function (dummySubEntity) {
            if (_this.buttonConfig.defaultValues.defaultValueFieldSystemName) {
                return _this.classifierService.loadClassifiersByIds(_this.buttonConfig.defaultValues.defaultValueFieldCompoundName, [_this.buttonConfig.defaultValues.defaultValueFieldValue]).pipe(operators_1.map(function (classifiersResponse) {
                    dummySubEntity.getProperty(_this.buttonConfig.defaultValues.defaultValueFieldSystemName).value = classifiersResponse.getData()[0];
                    return dummySubEntity;
                }));
            }
            return of_1.of(dummySubEntity);
        }));
        Observable_1.Observable.zip(subEntityMetaFields$, mainEntityMetaFields$, searchFilterName$, dummySubEntity$)
            .takeUntil(this._destroy$)
            .subscribe(function (_a) {
            var subEntityMetaFields = _a[0], mainEntityMetaFields = _a[1], searchFilterName = _a[2], subEntity = _a[3];
            _this.tableTitle = searchFilterName ? searchFilterName + " " + _this.rootTableTitle : _this.rootTableTitle;
            var columnMetaFields = [];
            var keywordMetaFields = [];
            var subEntitySelectedItemFields = [];
            var mainEntitySelectedItemFields = [];
            subEntityMetaFields.forEach(function (metaField) {
                if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY) {
                    _this._subEntityIdentityFieldId = metaField.getSystemName();
                }
                else if (metaField.getType() === idm_kb_service_client_js_1.MetaFieldType.PARENT) {
                    _this._subEntityParentFieldId = metaField.getSystemName();
                }
                if (_this.buttonConfig.selectedItemFields.some(function (metaFieldId) { return metaFieldId["systemName"] === metaField.getSystemName(); })) {
                    subEntitySelectedItemFields.push(metaField);
                }
            });
            mainEntityMetaFields.forEach(function (metaField) {
                if (_this.buttonConfig.columns.indexOf(metaField.getSystemName()) !== -1) {
                    columnMetaFields.push(metaField);
                }
                if (_this.buttonConfig.searchKeywords.indexOf(metaField.getSystemName()) !== -1) {
                    keywordMetaFields.push(metaField);
                }
                if (_this.buttonConfig.selectedItemFields.some(function (metaFieldId) { return metaFieldId["systemName"] === metaField.getSystemName(); })) {
                    mainEntitySelectedItemFields.push(metaField);
                }
            });
            // Set response column metaField sequence as configured
            _this.buttonConfig.columns.forEach(function (columnSystemName) {
                return _this.columnMetaFields.push(columnMetaFields.find(function (metaField) { return columnSystemName === metaField.getSystemName(); }));
            });
            _this.buttonConfig.searchKeywords.forEach(function (columnSystemName) {
                return _this.keywordMetaFields.push(keywordMetaFields.find(function (metaField) { return columnSystemName === metaField.getSystemName(); }));
            });
            _this.buttonConfig.selectedItemFields.forEach(function (selectedItem) {
                _this.selectedItemFields.push(selectedItem["metaCategoryId"]["systemName"] === _this.mainEntityCategoryId ?
                    mainEntitySelectedItemFields.find(function (metaField) { return selectedItem["systemName"] === metaField.getSystemName(); })
                    :
                        subEntitySelectedItemFields.find(function (metaField) { return selectedItem["systemName"] === metaField.getSystemName(); }));
            });
            _this._dummySubEntity = subEntity;
            _this.isReady = true;
            if (_this.newEntity) {
                _this.onAddEvent(_this.newEntity);
            }
        });
    };
    BulkPickerPopupComponent.prototype.isSubEntityUnique = function (newSubEntity) {
        var _this = this;
        if (this.selectedSubEntities && this.selectedSubEntities.length === 0) {
            return of_1.of(true);
        }
        var newSubEntityForCompare = lodash_1.cloneDeep(newSubEntity);
        newSubEntityForCompare.getProperty("entityId").value = null;
        var entityComparisonResults = this.selectedSubEntities.map(function (subEntity) {
            var subEntityForCompare = lodash_1.cloneDeep(subEntity);
            subEntityForCompare.getProperty("entityId").value = null;
            return fromPromise_1.fromPromise(_this._entityComparisonHelper.equals(_this.subEntityCategoryId, subEntityForCompare, newSubEntityForCompare));
        });
        return Observable_1.Observable.zip.apply(Observable_1.Observable, entityComparisonResults).pipe(operators_1.map(function (results) {
            return !results.some(function (isEqual) { return isEqual; });
        }));
    };
    BulkPickerPopupComponent.prototype.ngOnDestroy = function () {
        this._destroy$.next();
        this._destroy$.complete();
    };
    BulkPickerPopupComponent.prototype.onFilterChanged = function (newFilterCriteria) {
        this._filterCriteria = newFilterCriteria;
        this._currentPage = 0;
        this.updateEntitiesSubject.next();
    };
    BulkPickerPopupComponent.prototype.onAddEvent = function (row) {
        var _this = this;
        var subEntity = this._dummySubEntity.clone();
        subEntity.getProperty(this._subEntityParentFieldId).value = this.entity.getId();
        subEntity.getProperty(this._subEntityIdentityFieldId).value = idm_de_service_client_js_1.getUniqueIdForSubEntity(this.entity, this._subEntityFieldId);
        subEntity.getProperty(this.mainEntityFieldId).value = row;
        if (this.buttonConfig.subFormId) {
            this._isAddAction = true;
            this._form.actions.openPopup(this._form, this.subEntityCategoryId, '', subEntity, this.buttonConfig.subFormId);
        }
        else {
            this.calculateAndValidate(subEntity)
                .take(1)
                .takeUntil(this._destroy$)
                .subscribe(function (data) {
                var validations = data.validations;
                if (validations.length) {
                    window.alert(validations[0].getMessage().getValue(_this.currentLanguageId));
                }
                else {
                    _this.entity.getProperty(_this.subEntityCategoryId).value.push(data.calculatedSubEntity);
                    _this.selectedSubEntities.push(data.calculatedSubEntity);
                }
            });
        }
    };
    BulkPickerPopupComponent.prototype.createNewEntity = function () {
        this.dialogRef.close({ action: dialog_action_1.DialogAction.NEW_ENTITY, entities: this.selectedSubEntities });
    };
    BulkPickerPopupComponent.prototype.onCancel = function () {
        this.dialogRef.close({ action: dialog_action_1.DialogAction.CANCEL });
    };
    BulkPickerPopupComponent.prototype.onSave = function () {
        this.dialogRef.close({ action: dialog_action_1.DialogAction.SAVE });
    };
    BulkPickerPopupComponent.prototype.setPopupData = function (data) {
        this.entity = data.entity;
        this.buttonConfig = data.buttonConfig;
        this.currentLanguageId = data.currentLanguageId;
        this.rootTableTitle = data.rootTableTitle;
        this.mainEntityImageFieldName = data.mainEntityImageFieldName;
        this.selectedSubEntities = data.selectedSubEntities;
        this.newEntity = data.newEntity;
        this.targetMainEntityMetaField = data.targetMainEntityMetaField;
        this.subEntityCategoryId = this.targetMainEntityMetaField['metaFieldId']['metaCategoryId']['systemName'];
        this.mainEntityCategoryId = this.targetMainEntityMetaField['compoundCategorySystemName'];
        this.mainEntityFieldId = this.targetMainEntityMetaField['metaFieldId']['systemName'];
        this._form = data.form;
        this._categoryId = data.categoryId;
        this._subEntityFieldId = data.subEntityFieldId;
        this.idPrefix = data.idPrefix;
    };
    BulkPickerPopupComponent.prototype.calculateAndValidate = function (subEntity) {
        var _this = this;
        var clonedEntity = this.entity.clone();
        clonedEntity.getProperty(this._subEntityFieldId).value.push(subEntity);
        return this.deSerializationService.serializeEntity(this._categoryId, clonedEntity)
            .pipe(operators_1.switchMap(function (serializedEntity) {
            return _this.validationService.calculateAndValidateField(_this._categoryId, _this._subEntityFieldId, serializedEntity);
        }), operators_1.switchMap(function (validationsCalculationsData) {
            var validations = validationsCalculationsData.getValidations();
            _this.inDrawer = _this._form && _this._form.inDrawer;
            if (validations.length) {
                return of_1.of({ calculatedSubEntity: null, validations: validations });
            }
            else {
                var serializedAndCalculatedSubEntity = validationsCalculationsData.getData()[_this._subEntityFieldId]
                    .find(function (serializedSubEntity) { return serializedSubEntity[_this._subEntityIdentityFieldId] === subEntity.getId(); });
                return _this.deSerializationService.deserializeSubEntity(_this.subEntityCategoryId, of_1.of(serializedAndCalculatedSubEntity))
                    .map(function (calculatedSubEntity) { return ({ calculatedSubEntity: calculatedSubEntity, validations: validations }); });
            }
        }));
    };
    Object.defineProperty(BulkPickerPopupComponent.prototype, "currentPage", {
        get: function () {
            return this._currentPage;
        },
        set: function (page) {
            this._currentPage = page;
            this.updateEntitiesSubject.next();
        },
        enumerable: true,
        configurable: true
    });
    BulkPickerPopupComponent = __decorate([
        core_1.Component({
            selector: 'ejustice-bulk-picker-popup',
            template: require('./bulk-picker-popup.component.html'),
            styles: [require('./bulk-picker-popup.component.css')]
        }),
        __param(9, core_1.Inject(material_1.MAT_DIALOG_DATA)),
        __metadata("design:paramtypes", [material_1.MatDialogRef, idm_kb_service_client_js_1.KbService, idm_de_service_client_js_1.DeService,
            idm_entity_search_client_js_1.EntitySearchService, idm_classifier_service_client_js_1.ClassifierService, material_1.MatDialog,
            idm_dynamic_forms_controls_1.ExtractionService, idm_validation_calculation_service_client_js_1.ValidationService,
            idm_de_service_client_js_1.DeSerializationService, Object])
    ], BulkPickerPopupComponent);
    return BulkPickerPopupComponent;
}());
exports.BulkPickerPopupComponent = BulkPickerPopupComponent;
//# sourceMappingURL=bulk-picker-popup.component.js.map